export const GET_LIST_DATA = 'GET_LIST_DATA';
export const GET_LIST_DATAONE = 'GET_LIST_DATAONE';
export const GET_LIST_DATATWO = 'GET_LIST_DATATWO';
export const GET_LIST_DATATHREE = 'GET_LIST_DATATHREE';
export const GET_LIST_DATAFOUR = 'GET_LIST_DATAFOUR';
export const GET_LIST_DATAFIVE = 'GET_LIST_DATAFIVE';
export const GET_LIST_DATASIX = 'GET_LIST_DATASIX';
export const GET_LIST_DATASEVEN = 'GET_LIST_DATASEVEN';
export const GET_LIST_DATAEIGHT = 'GET_LIST_DATAEIGHT';
export const GET_LIST_DATANINE = 'GET_LIST_DATANINE';
export const GET_LIST_DATATEN = 'GET_LIST_DATATEN';
export const GET_LIST_ISFETCHING = 'GET_LIST_ISFETCHING';
export const GET_SLIDERDATA_LIST = 'GET_SLIDERDATA_LIST';
export const GET_GOODS_CATEGORY_LIST = 'GET_GOODS_CATEGORY_LIST';
export const GET_QUALITYGOODS_LIST = 'GET_QUALITYGOODS_LIST';
export const GET_CARTGOODS_LIST = 'GET_CARTGOODS_LIST';
export const GET_HOT_SEARCH = 'GET_HOT_SEARCH';
export const GET_HISTORY_SEARCH = 'GET_HISTORY_SEARCH';
export const GET_LOCAL_HISTORY = 'GET_LOCAL_HISTORY';
export const GET_GOODS_DETAIL = 'GET_GOODS_DETAIL';
export const GET_SALE_PURCHASE = 'GET_SALE_PURCHASE';
export const GET_LOGINSTATUS = 'GET_LOGINSTATUS';
export const GET_ISWECHAT = 'GET_ISWECHAT';
export const SHOW_NULL_PAGE = 'SHOW_NULL_PAGE';
export const GET_SUB_CATEGORY_LIST = 'GET_SUB_CATEGORY_LIST';
export const GET_SALE_BANNER = 'GET_SALE_BANNER';
export const GET_SALE_QUALITY = 'GET_SALE_QUALITY';
export const GET_SALE_PRO_LIST = 'GET_SALE_PRO_LIST';
export const GET_CARD_LIST = 'GET_CARD_LIST';
export const GET_COUPON_LIST = 'GET_COUPON_LIST';
